import React from 'react';
import { RadioGroup, List } from '@material-ui/core';

import InsuranceTypeListItem from '../InsuranceTypeListItem';
import useCar from '../../../../../../context/useCar';
import { useTranslations } from 'components/utilities';

const InsuranceTypeList = () => {
	const { t } = useTranslations();

	const {
		insurance,
		handleChangeInsurance,
		carDetails: {
			car: { insurance_price }
		}
	} = useCar();

	return (
		<RadioGroup value={insurance ? 1 : 0} onChange={handleChangeInsurance}>
			<List>
				<InsuranceTypeListItem
					title={t('car.insuranceFree')}
					description={t('car.insuranceDesc')}
					value={0}
				/>
				<InsuranceTypeListItem
					title={t('car.insurancePaid')}
					description={t('car.insuranceDesc')}
					value={1}
					price={insurance_price}
				/>
			</List>
		</RadioGroup>
	);
};

export default InsuranceTypeList;
